import {IController} from "angular";
import * as angular from "angular";
import {Expense} from "../../models/expenses.model";

export class ExpenseOverviewComponent implements IController {

  expenseId: string;

  public loading: boolean;
  public expense: Expense;

  constructor(private $expense) {
  }

  $onInit() {
    this.loading = true;
    this.$expense(this.expenseId).$asyncValue().then(
      (expense) => {
        this.expense = expense;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.expenseId && !changes.expenseId.isFirstChange()) {
      this.$onInit()
    }
  }

}

angular
  .module('bringoz.admin.expenses')
  .component('expenseOverview', {
    bindings: {
      expenseId: '<'
    },
    template: require('./expense-overview.html').default,
    controller: ExpenseOverviewComponent
  });
